import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders, umsUrl, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { USER_PENDING_REQUEST_COUNT, USER_PENDING_REQUEST_COUNT_SUCCESS, USER_PENDING_REQUEST_COUNT_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';

function* getUserPendingRequestCount({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];
    // const { userId } = payload.data;

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/admin/profile/pending-request`,
      method: 'GET',
      headers: {
        // Authorization: Constant?.CLIENT_TOKEN,
        ...filteredHeaders,
        // withCredentials: true
      },
      params: payload?.urlParams,
    });

    if (response.status === 200) {
      yield put({
        type: USER_PENDING_REQUEST_COUNT_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: USER_PENDING_REQUEST_COUNT_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: USER_PENDING_REQUEST_COUNT_ERROR, payload: error });
  }
}

export function* watchUserPendingRequestCount() {
  yield takeEvery(USER_PENDING_REQUEST_COUNT, getUserPendingRequestCount);
}

function* userPendingRequestCountSaga() {
  yield all([fork(watchUserPendingRequestCount)]);
}

export default userPendingRequestCountSaga;
